import * as React from "react";
import { cn } from "@/lib/utils";

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => {
    return (
      <textarea
        ref={ref}
        className={cn(
          "flex w-full rounded-md border border-border bg-input px-3 py-2",
          "text-sm ring-offset-background text-foreground placeholder:text-muted-foreground",
          "transition-[border-color,box-shadow,color] duration-150",
          "focus:outline-none focus-visible:outline-none",
          "focus:border-ring focus-visible:border-ring",
          "focus:ring-2 focus-visible:ring-2 focus:ring-ring/30 focus-visible:ring-ring/30",
          "focus:ring-offset-0 focus-visible:ring-offset-0",
          "disabled:cursor-not-allowed disabled:opacity-50",
          className,
        )}
        {...props}
      />
    );
  },
);

Textarea.displayName = "Textarea";

export { Textarea };
